import React from 'react'
import {Button, UnderlinedHeader} from 'src/components'
import {useAppSelector} from "../../../store/hooks";
import {selectReleaseToggles} from "../../../ReleaseToggles/releaseTogglesSlice";
import {selectClientDocuments} from "../../../Resources/clientMeetingDocumentSlice";

function LegalDocumentsSection() {
    const enableEstateFlowchartMVPRelease = useAppSelector(selectReleaseToggles)?.enableEstateFlowchartMVPRelease;
    const clientDocumentsSubMenus = useAppSelector(selectClientDocuments);

    return (
        <section className={"legal-documents-section"}>
            {enableEstateFlowchartMVPRelease ? (
                <UnderlinedHeader className={"legal-documents-header"}
                                  leftAlignedContent={
                                      <h4>Legal Documents</h4>
                                  }
                                  rightAlignedContent={
                                      <Button
                                          className={"add-legal-document-button"}
                                          onClick={() => {
                                              window.open(clientDocumentsSubMenus.webUrl, "_blank");
                                          }}
                                          icon="right"
                                          iconName="launch"
                                          kind="borderless"
                                      >
                                          <span className="add-powers-of-appointment-label">Access Your Sharepoint</span>
                                      </Button>
                                  }
                />
            ) : (
                <UnderlinedHeader className={"legal-documents-header"}
                                  leftAlignedContent={
                                      <h4>Legal Documents</h4>
                                  }
                                  rightAlignedContent={
                                      <Button
                                          className={"add-legal-document-button"}
                                          onClick={() => {}}
                                          icon="left"
                                          iconName="paperclip"
                                          kind="borderless"
                                      >
                                          <span className="add-powers-of-appointment-label">ATTACH</span>
                                      </Button>
                                  }
                />
            )}
            {enableEstateFlowchartMVPRelease && <div className={"legal-documents-section-description"}>
                <p>
                    Documents must be uploaded to the Client Documents folder on SharePoint. To add or manage documents,
                    access your SharePoint via the button above.
                </p>
                <p>
                    If you’d like to view any existing documents, you can open the Client Documents preview
                    pane via the <b>Resources</b> tab in the left navigation.
                </p>
            </div>}
        </section>
    )
}

export default LegalDocumentsSection